export class PatientAdditionalNoteInputDTO {
    note = "";
    createdBy = "";
    createdOn = "";
}

export class PatientAdditionalNoteOutputDTO {
    note = "";
}